import { NTHFlag } from '../constants/flag';
import { BaseModelDTO } from './baseModelDTO';
import { BasicBonModelDTO } from './basicBonModelDTO';
import { BcLineModelDTO } from './bcLineModelDTO';


export class BcModelDTO extends BasicBonModelDTO {
    public bcSite: BaseModelDTO;
    public bcFournisseur: BaseModelDTO;
    public bcJProvis: BaseModelDTO;
    public bcCgProvis: BaseModelDTO;
    public bcCa1: BaseModelDTO;
    public bcModeRegl: BaseModelDTO;
    public bcCondRegl: BaseModelDTO;
    public bcTva1: BaseModelDTO;
    public bcTva2: BaseModelDTO;
    public bcTva3: BaseModelDTO;
    public bcSociety: BaseModelDTO;
    public bcSiteLivr: BaseModelDTO;
    public bcLines: BcLineModelDTO[] = [];
    public dBc: Date;
    public dRegl: Date;
    public dLivraison: Date;
    public ht: number = 0;
    public tva: number = 0;
    public ttc: number = 0;
    public valid: boolean;
    public mention: string;
    public commentaires: string;
    public refFourn: string;
}
